<template>
  <v-container fluid pa-0>
    <v-layout row class="content-area-layout">
      <v-flex xs12 fill-height style="overflow-y: auto;">
        <activity-summary-table :sort="sort" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ActivitySummaryTable from '@/ux/components/activities/ActivitySummaryTable.vue';
import eventBus from '@/events/eventBus';
import logger from '@/domain/ClientLogger';

export default {
  name: 'activity-summary-view',
  props: {
    sort: {
      type: String,
      required: false,
      default: 'start_date',
    },
    direction: {
      type: String,
      required: false,
      default: 'desc',
    },
  },
  components: {
    ActivitySummaryTable,
  },
  watch: {
  },
  mounted() {
    eventBus.on('pagination-changed', this.onPaginationChanged);
  },
  beforeDestroy() {
    eventBus.off('pagination-changed', this.onPaginationChanged);
  },
  methods: {
    onPaginationChanged(p) {
      const pd = p.descending ? 'desc' : 'asc';
      logger.log(`onPaginationChanged(${p.sortBy},${pd})`);
      if ((p.sortBy !== this.sort) || (pd !== this.direction)) {
        this.$router.push({ name: 'activitySummary', params: { sort: `${p.sortBy}`, direction: p.descending ? 'desc' : 'asc' } });
      }
    },
  },
};
</script>

<style>
</style>
